// models component
import ShipFeature from '@/models/ShipFeature'
import Ship from '@/models/Ship'
import Traffic from '@/models/Traffic'
import ShipSailor from '@/models/ShipSailor'
import Ordering from '@/models/Ordering'
import ShipUser from '@/models/ShipUser'
import ShipLaborPrivilege from '@/models/ShipLaborPrivileges'

export default class Initialize {
    // Ship Management Service Initialize
    static of() {
        return Promise.resolve()
            .then(function () {
                // delete data
                return Promise.all([
                    ShipSailor.deleteAll(),
                    ShipFeature.deleteAll(),
                    Traffic.deleteAll(),
                    Ordering.deleteAll(),
                    ShipUser.deleteAll(),
                    ShipLaborPrivilege.deleteAll()
                ])
            })
            .then(function () {
                return Promise.all([
                    ShipFeature.api().fetch(),
                    Ship.api().fetch(),
                    Traffic.api().fetch(),
                    Ordering.api().fetch(),
                ])
            })
            // .then(function () {
            //     return ShipFeature.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('ShipFeature.all()', ShipFeature.all())
            //         })
            // })
            // .then(function () {
            //     return Ship.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log("Ship.all()", Ship.all());
            //         })
            // })
            // .then(function () {
            //     return ShipSailor.deleteAll()
            // })
            // .then(function () {
            //     Traffic.deleteAll()
            //     return Traffic.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('Traffic.one()', Traffic.one())
            //         })
            // })
            // .then(function () {
            //     Ordering.deleteAll()
            //     return Ordering.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('Ordering.one()', Ordering.one())
            //         })
            // })
            .then(function () {
                // ShipUser.deleteAll()
                // ShipLaborPrivilege.deleteAll()
                const ships = Ship.all()
                if (ships.length > 0 && ships[0].id) {
                    return Promise.all([
                        ShipUser.api().fetch(ships[0].id),
                        ShipLaborPrivilege.api().fetch(ships[0].id),
                    ])
                }
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
